<script>
import toasts from "../../mixins/toasts";

export default Vue.extend({
  props: ["subject"],
  mixins: [toasts],
  methods: {
    submit: function() {},
    remove: function() {
      this.$dialog.confirm({
        title: "Удаление предмета",
        message: `Вы уверены, что хотите удалить этот предмет?`,
        confirmText: "Удалить предмет",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/subjects/${this.subject.id}`)
            .then(response => {
              this.toast("success", "Предмет был успешно удалён");
              _.delay(() => {
                window.open("/subjects", "_self");
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/subjects/Show.vue